export default __webpack_public_path__ + "static/more_info_wt-2188d1b84659dac9e1e8b7254a16202b.pdf";